/* Scripts para Ocultar Productos */
if (window.location.href.indexOf("10ml-parfum-re-fillable") > -1){
    window.location.replace("https://houseofbo.co/products/tesoro-discovery-travel-set-new-config");
};


if (window.location.href.indexOf("10ml-parfum-re-fillable-40-usd") > -1){
    window.location.replace("https://houseofbo.co");
};

if (window.location.href.indexOf("travel-set-box") > -1){
    window.location.replace("https://houseofbo.co/products/tesoro-discovery-travel-set-new-config");
};


if (window.location.href.indexOf("travel-coffret-box") > -1){
    window.location.replace("https://houseofbo.co/products/discovery-travel-coffret");
};


if (window.location.href.indexOf("free-sample-1-8ml-1") > -1){
    window.location.replace("https://houseofbo.co");
};

if (window.location.href.indexOf("gift-nourishing-parfum-primer") > -1){
    window.location.replace("https://houseofbo.co/products/bo-nourishing-parfum-primer");
};

if (window.location.href.indexOf("package-protection") > -1){
    window.location.replace("https://houseofbo.co");
};

if (window.location.href.indexOf("gift-10ml-parfum") > -1){
    window.location.replace("https://houseofbo.co");
};

if (window.location.href.indexOf("https://houseofbo.co/products/nourishing-parfum-primer") > -1){
    window.location.replace("https://houseofbo.co/products/tesoro-collection-gift-set");
};

if (window.location.href.indexOf("https://houseofbo.co/products/75ml-parfum") > -1){
    window.location.replace("https://houseofbo.co/products/tesoro-collection-gift-set");
};

if (window.location.href.indexOf("https://houseofbo.co/products/tesoro-collection-set-box") > -1){
    window.location.replace("https://houseofbo.co/products/tesoro-collection-gift-set");
};

if (window.location.href.indexOf("free-sample-casa-blanca-2ml") > -1){
    window.location.replace("https://houseofbo.co");
};



/* Script Load Cart */

$('.open-cart-rebuy').click(function() {
  cartLoad();
});

function cartLoad(){
  if (typeof Rebuy === 'undefined' || typeof Rebuy.SmartCart === 'undefined' || typeof Rebuy.SmartCart.show !== 'function') {
    RebuyPreload();
  } else {
    Rebuy.SmartCart.show();
  };
};

function RebuyPreload(){
  $('body').addClass('show-cart-preload');
};

function cartReady(){
  if ($('body').hasClass('show-cart-preload')) {
    setTimeout(function() {
      $('body').removeClass('show-cart-preload');
      Rebuy.SmartCart.show();
    }, 1000);
  };
};

/* Script Add to Cart Button */

function btnAddToCartLoad(){
  $('div#load-btn-cart').hide();
  $('button#btn-to-cart').show();
  $('span#add-to-cart-property').show();
  $('span.add-to-cart--sets').css('display','inline-block');
};

/* Script Gift With Purchase */

function renderGift(){

  var $maxCheckbox = MaxGWP;     
  
  $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-recommendations').prepend(
    '<div class="rebuy-cart__flyout-gift">' +
      '<div class="rebuy-cart__gift-variants">' +
        '<div class="rebuy-cart__gift-variants-container">' +
          '<div class="rebuy-cart__gift-message">' +
            '<h4>Please select your complimentary sample</h4>' +
            '<p><span>(0/1)</span> sample selected</p>' +
          '</div>' +
          '<div class="rebuy-cart__gift-variants-content"></div>' +
        '</div>' +
      '</div>' +
    '</div>'
  );

  var $containerVariants = $(".rebuy-cart__flyout-gift .rebuy-cart__gift-variants .rebuy-cart__gift-variants-container .rebuy-cart__gift-variants-content");
  $.each(ArrayGiftRebuy, function(index, objeto) {
    var maxQuantity = (objeto.inventory > 1) ? $maxCheckbox : objeto.inventory;
    var htmlGift = `
      <div class="inputs-variants sets-container__variants-checkbox-rebuy product__${objeto.nameHandleize}">
        <input type="radio" id="${objeto.productHandleize}_${objeto.nameHandleize}" name="variants-rebuy-gift" value="${objeto.id}"/>
        <label for="${objeto.productHandleize}_${objeto.nameHandleize}">
          <div class="inputs-variants__image"><img src="${objeto.imagen}" alt="${objeto.name}"></div>
          <div class="inputs-variants__text"><h2>${objeto.name}</h2><p>${objeto.essence}</p></div>
        </label>

        <div class="quantity-global" data-quantity="${objeto.inventory}">
          <div class="container-qty">
            <span class="minus disabled-button">&minus;</span>
            <input type="number" class="input-box" value="1" min="1" max="${maxQuantity}" readonly>
            <span class="plus ${objeto.inventory == 1 ? 'disabled-button' : ''}">&plus;</span>
          </div>
          <p class="remaining ${objeto.inventory <= 5 ? 'active-available' : ''}">Only ${objeto.inventory} remaining</p>
        </div>
      </div>
    `;
    $containerVariants.append(htmlGift);
  });

  $containerVariants.slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  

};

/*
$(document).on('change', '#gift-with-purchase-rebuy', function (){
  if ($(this).is(":checked")) {
    $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants').slideDown();
    resetInputsRebuy();
  } else {
    $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants').slideUp();
    resetInputsRebuy();
  };
});*/

$(document).on('change', '.rebuy-cart__gift-variants-content .sets-container__variants-checkbox-rebuy > input', function (){
  validationGiftQty($(this));
  let $dropdown = $(this).siblings('.quantity-global');
  let $max = $dropdown.find('.container-qty input.input-box').attr('max');
  $dropdown.find('.container-qty input.input-box').val(1);
  $dropdown.find('.container-qty .minus').addClass('disabled-button');
  if($max > 1){
    $dropdown.find('.container-qty .plus').removeClass('disabled-button');
  }
  /*if ($(this).is(':checked')) {
    $dropdown.slideDown();
  } else {
    $dropdown.slideUp();
  }*/

  let productId = $(this).val();
  addGiftWithPurchase(productId);
  
});


function addGiftWithPurchase(id) {
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      console.log('Carrito:', cart);
      
      let targetProductId = 8065885929700;
      let itemsToRemove = cart.items.filter(item => item.product_id === targetProductId);
      
      if (itemsToRemove.length > 0) {
        console.log(`Se encontraron ${itemsToRemove.length} variantes del producto con ID ${targetProductId}. Eliminándolas...`);
        
        let updateData = itemsToRemove.reduce((acc, item) => {
          acc[item.key] = 0;
          return acc;
        }, {});

        jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: JSON.stringify({ updates: updateData }),
          dataType: 'json',
          contentType: 'application/json',
          success: function(response) {
            console.log('Productos eliminados correctamente:', response);
            addNewGift(id);
          },
          error: function(xhr, status, error) {
            console.error('Error al eliminar productos:', xhr.responseText);
          }
        });

      } else {
        console.log(`No hay productos con el product_id ${targetProductId} en el carrito. Agregando el nuevo...`);
        addNewGift(id);
      }
    },
    error: function(xhr, status, error) {
      console.error('Error al obtener el carrito:', xhr.responseText);
    }
  });
}

function addNewGift(id) {
  var dataProduct = {
    "id": id,
    "quantity": 1
  };

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $.param(dataProduct),
    dataType: 'json',
    success: function(response) { 
      console.log('Producto agregado correctamente:', response);
    },
    error: function(xhr, status, error) {
      console.error('Error al agregar el producto:', xhr.responseText);
    }
  });
}



$(document).on('click', '.rebuy-cart__gift-variants-content .quantity-global .minus', function (){
  let $input = $(this).siblings('.input-box');
  let currentValue = parseInt($input.val(), 10);
  let minValue = parseInt($input.attr('min'), 10);
  if (!isNaN(currentValue) && currentValue > minValue) {
    $input.val(currentValue - 1);
  }
  btnsQuantity($(this), false);
  let checkbox = $(this).parent('.quantity-global').siblings('input');
  validationGiftQty(checkbox);
});

$(document).on('click', '.rebuy-cart__gift-variants-content .quantity-global .plus', function (){
  let $input = $(this).siblings('.input-box');
  let currentValue = parseInt($input.val(), 10);
  let maxValue = parseInt($input.attr('max'), 10);
  if (!isNaN(currentValue) && currentValue < maxValue) {
    $input.val(currentValue + 1);
  }
  btnsQuantity($(this), true);
  let checkbox = $(this).parent('.quantity-global').siblings('input');
  validationGiftQty(checkbox);
});

function btnsQuantity(button, increment) {
  let input = button.siblings('.input-box');
  let currentValue = parseInt(input.val(), 10);
  let max = parseInt(input.attr('max'), 10);
  let min = parseInt(input.attr('min'), 10);
  if (increment) {
    if (currentValue < max) {
        button.removeClass('disabled-button');
    }
    if (currentValue >= max) {
        button.addClass('disabled-button');
    }
    button.siblings('.minus').removeClass('disabled-button');
  } else {
    if (currentValue > min) {
        button.removeClass('disabled-button');
    }
    if (currentValue <= min) {
        button.addClass('disabled-button');
    }
    button.siblings('.plus').removeClass('disabled-button');
  }
}

function validationGiftQty(Input){
  $('.rebuy-cart__gift-variants .message-fail-select-rebuy').hide();  
  let checkedCheckboxes = $('.rebuy-cart__gift-variants-content .sets-container__variants-checkbox-rebuy > input:checked');
  let totalQuantitySum = 0;
  $(checkedCheckboxes).each(function(){
    let totalQuantitys = parseInt($(this).siblings('.quantity-global').find('.container-qty .input-box').val(), 10);
    if (!isNaN(totalQuantitys)) {
      totalQuantitySum += totalQuantitys;
    }
  });
  if (totalQuantitySum > MaxGWP) {
    Input.prop('checked', false); 
    $('.rebuy-cart__gift-variants-content .quantity-global .container-qty .plus').addClass('block-button-global');
  } else if(totalQuantitySum >= MaxGWP){
    //$('.rebuy-cart__gift-variants .rebuy-cart__gift-message p span').replaceWith('<span>(' + totalQuantitySum + '/' + totalQuantitySum + ')</span>');
    $('.rebuy-cart__gift-variants-content .quantity-global .container-qty .plus').addClass('block-button-global');
  } else {
    //$('.rebuy-cart__gift-variants .rebuy-cart__gift-message p span').replaceWith('<span>(' + totalQuantitySum + '/' + MaxGWP + ')</span>');
    $('.rebuy-cart__gift-variants-content .quantity-global .container-qty .plus').removeClass('block-button-global');
  };
};


function giftWithPurchase(qty,gift){

    var $quantity = qty;
    var $gift = gift;

    var giftProductId = 8065885929700;

    var productIdsToCheck = [
      8032285622500, 8163953508580, 8163931390180, 7803030667492, 8032273334500, 7803031093476, 8032091898084, 8163877683428, 7803025948900, 8580057301220, 8687926280420,
      8498839355620, 8498888966372, 8498890277092, 8498891489508, 8498892308708, 8498894012644, 8498894897380, 8498897223908, 8498900107492, 8580147118308, 8713300902116
    ];

    var hasActivator = gift.some(item => productIdsToCheck.includes(item.product_id));
    var existingGifts = gift.filter(item => item.product_id === giftProductId);
    var totalQtyGift = existingGifts.reduce((sum, item) => sum + item.quantity, 0);

    if (hasActivator) {
      $('.rebuy-cart__flyout-body .rebuy-cart__flyout-gift').show();
      $('.rebuy-cart__flyout-body .rebuy-cart__flyout-gift .slick-slider').slick('setPosition');
      if (totalQtyGift > 1) {
        removeAllGifts(existingGifts);
      }
    } else {
      if (existingGifts.length > 0) {
        removeAllGifts(existingGifts);
      }
      $('.rebuy-cart__flyout-body .rebuy-cart__flyout-gift').hide();
      resetInputsRebuy();
    }

    markSelectedGift(existingGifts);

};


function removeAllGifts(existingGifts) {
    let updates = {};
    existingGifts.forEach(item => {
        updates[item.key] = 0;
    });

    jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: JSON.stringify({ updates: updates }),
        dataType: 'json',
        contentType: 'application/json',
        success: function(response) {
            // console.log('Regalos eliminados correctamente:', response);
            resetInputsRebuy();
        },
        error: function(xhr, status, error) {
            // console.error('Error al eliminar los regalos:', xhr.responseText);
        }
    });
}



function markSelectedGift(existingGifts) {
    if (existingGifts.length > 0) {
        $('.rebuy-cart__gift-variants .rebuy-cart__gift-message p span').replaceWith('<span class="active-items">(1/1)</span>');

        let selectedVariantId = existingGifts[0].variant_id;
        let selectedIndex = 0;
        let slickSlider = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-gift .slick-slider');

        $('input[name="variants-rebuy-gift"]').each(function(){
            if ($(this).val() == selectedVariantId) {
                $(this).prop('checked', true);
                let parentSlide = $(this).closest('.slick-slide');
                selectedIndex = parseInt(parentSlide.attr('data-slick-index'), 10);
            }
        });

        if (slickSlider.hasClass('slick-initialized')) {
            setTimeout(function() {
              let slickInstance = slickSlider.slick('getSlick');
              if (!slickInstance) {
                  // console.error('⛔ No se pudo obtener la instancia de Slick.');
                  return;
              }
              let slidesToShow = slickInstance.options.slidesToShow; // Número de slides visibles
              let totalSlides = slickInstance.slideCount; // Total de slides
              let adjustedIndex = Math.max(0, Math.min(selectedIndex, totalSlides - slidesToShow));
              slickSlider.slick('slickGoTo', adjustedIndex);
            }, 500);
        }
    }
}


function resetInputsRebuy(){
    // console.log("⚠️ No hay regalos seleccionados. Reseteando la UI.");
    
    $('.rebuy-cart__gift-variants .rebuy-cart__gift-message p span').replaceWith('<span>(0/1)</span>');
    
    let variants = $('.rebuy-cart__gift-variants-container .rebuy-cart__gift-variants-content .inputs-variants');
    variants.each(function(){
        $(this).find('.quantity-global').hide();
        $(this).find('input[name="variants-rebuy-gift"]').prop('checked', false);
        let maxInput = $(this).find('.quantity-global .container-qty input.input-box').attr('max');
        $(this).find('.quantity-global .container-qty input.input-box').val(1);
        $(this).find('.quantity-global .container-qty .minus').addClass('disabled-button');
        if (maxInput > 1) {
            $(this).find('.quantity-global .container-qty .plus').removeClass('disabled-button');
        }
    });

    let slickSlider = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-gift .slick-slider');
    if (slickSlider.hasClass('slick-initialized')) {
        slickSlider.slick('slickGoTo', 0);
    }
}





/* Script Render GWP */

function $renderContainer(){

  $(".rebuy-cart__flyout-body .rebuy-cart__flyout-content").prepend(

      '<div class="container-progress-bar">' +

        '<div class="elements-progress-bar">' +
      
            '<h3 class="progress-bar__title">Free shipping on all orders</h3>'+
            
            '<section class="progress-bar-cart">'+
            
            	'<div class="progress-bar-cart__container">'+
            		'<div id="progress-bar__free-shipping" class="progress-bar-cart__bar"></div>'+
            	'</div>'+
            
            	'<div class="progress-bar__icon">'+
            		'<div id="container-icon__free-shipping" class="progress-bar__icon-container">'+
            			'<i id="icon__free-shipping" class="fas fa-lock"></i>'+
            		'</div>'+
            		'<p class="progress-bar__icon-text">Free Shipping</p>'+
            	'</div>'+
      
      
              '<div class="progress-bar-cart__container">'+
            		'<div id="progress-bar__pouch" class="progress-bar-cart__bar"></div>'+
            	'</div>'+
            
            	'<div class="progress-bar__icon">'+
            		'<div id="container-icon__pouch" class="progress-bar__icon-container">'+
            			'<i id="icon__pouch" class="fas fa-lock"></i>'+
            		'</div>'+
            		'<p class="progress-bar__icon-text">$50 Gift Card</p>'+
            	'</div>'+
            
            '</section>'+
    
            '<div class="disclaimer-message">'+
    
              '<p>* The gift card will be given on purchases over $350 and will be sent after completing the purchase.</p>' +
        
            '</div>' +

        '</div>' +

    '</div>'
  );
  
};


/* Script Progress Bar */

function $progressBar(totalPrice,arrayProducts){

    var $total_price = totalPrice;
    var $array_products = arrayProducts;

    var $price_promotion_one = 100 - $total_price; var $promotion_one = $price_promotion_one /= Math.pow(10, 2); var $porcentPromotionOne = ((1.00 - $promotion_one) / 1.00 * 100) + "%";
    var $price_promotion_two = 35000 - $total_price; var $promotion_two = $price_promotion_two /= Math.pow(10, 2); var $porcentPromotionTwo = ((350.00 - $promotion_two) / 350.00 * 100) + "%";

    /*
    function $product_offer(productId){return productId.product_id === 8099743760612;};var $validation_product = $array_products.find($product_offer);

    if ($validation_product !== undefined) {
      if($total_price <= 17499){
        jQuery.post('/cart/update.js', {
            updates: {
              44380653715684: 0
            }
        });
      } else if ($total_price >= 17500){
        var $qty_product = $validation_product.quantity;
        if($qty_product > 1){
            jQuery.post('/cart/update.js', {
              updates: {
                44380653715684: 1
              }
            });
        };
      };
    };
    */

  
    if($total_price <= 0){

      $("#progress-bar__free-shipping,#progress-bar__5-off,#progress-bar__pouch").animate({width: "0%",}, 1000);
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>');
      $("#container-icon__free-shipping,#container-icon__pouch").css({"background-color": "#fff", "border-color": "#000"});
      $("#icon__free-shipping,#icon__pouch").css("color", "#000");
      $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Free shipping on all orders</h3>');
      
    } else if($total_price > 0 && $total_price <= 34999){

      $("#progress-bar__free-shipping").animate({width: "100%",}, 500);
      $("#progress-bar__pouch").animate({width: $porcentPromotionTwo,}, 500);
      
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>')
      
      $("#container-icon__free-shipping").css({"background-color": "#000", "border-color": "#000"});
      $("#container-icon__pouch").css({"background-color": "#fff", "border-color": "#000"});

      $("#icon__free-shipping").css("color", "#fff");
      $("#icon__pouch").css("color", "#000");

      $(".progress-bar__title").replaceWith(
        '<div class="progress-bar__title">'+
          '<h3>You need <b>$' + $promotion_two + '</b> to get $50 gift card</h3>' +
          '<h5>You unlocked free shipping</h5>'+
        '</div>'
      );

    } else if($total_price >= 35000){

      /*
      if ($validation_product === undefined){
        var dataProduct = {
          "id": 44380653715684,
          "quantity": 1
        }
        
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: dataProduct,
          dataType: 'json',
          success: function() { 
            console.log('Product: Agregado');
          }
        });
      };
      */

      $("#progress-bar__free-shipping").animate({width: "100%",}, 500);
      $("#progress-bar__pouch").animate({width: "100%",}, 500);

      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-check-circle"></i>');

      $("#container-icon__free-shipping,#container-icon__pouch").css({"background-color": "#000", "border-color": "#000"});

      $("#icon__free-shipping,#icon__pouch").css("color", "#fff");

      $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">You unlocked free shipping + gift card</h3>');
      
    };
  
};


/* Scripts Insurance */

function $renderInsurance(){
  $('.rebuy-cart__flyout-apps').prepend( 
    '<section class="insurance-personalized">' +
        '<div class="insurance-personalized__container">' +
            '<div class="logo">' +
                '<svg version="1.1" id="icon-svg-insure" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 185 200" style="enable-background:new 0 0 185 200;" xml:space="preserve"><g><path d="M92.4,200c-30.7-13.9-86.2-56.3-87.4-88.9L1.8,26.6C1.8,26.6,44.1,0,92.4,0s90.9,26.6,90.9,26.6l-3.4,84.5C178.6,143.7,123.3,186.1,92.4,200z M16.6,34.4l2.9,76.2c1,25.3,49.7,60.9,72.8,73.3V14.4c-19,0-38.2,4.6-55.8,11.2C30,28.3,23,31.2,16.6,34.4z M92.4,190.7c26.3-12.9,78.2-51.4,79.2-79.9l3.2-79.7C151.3,17.5,118.4,8.3,92.4,8.3c-19.7,0-39.7,4.6-58,11.7c-6.8,2.4-17.1,6.6-24.1,11l2.9,79.9C14.4,139.3,66.1,177.8,92.4,190.7z"/></g></svg>' +
            '</div>' +
            '<div class="message">' +
                '<h5>Package Protection</h5>' +
                '<p>Coverage for loss, theft, or transit damage.</p>' +
            '</div>' +
            '<div class="button-price">' +
                '<label class="switch">' +
                    '<input id="insurange-rebuy" type="checkbox">' +
                    '<span class="slider round"></span>' +
                '</label>' +
                '<p class="price">$10.00</p>' +
            '</div>' +
        '</div>' +
    '</section>'
  );
};





var isInsuranceUpdated = false;

function $insurance(totalPrice,arrayProducts){

    var $totalCart = totalPrice;
    var $array_products = arrayProducts;

    function $findInsurange(id) {
      return id.product_id === 8270493352164;
    };

    var $protectPackage = $array_products.find($findInsurange);

    if($protectPackage !== undefined){
      var $totalCart = totalPrice - $protectPackage.price;
    };

    if($totalCart >= 0 && $totalCart <= 24999){
      $('.rebuy-cart__flyout-apps .insurance-personalized .button-price .price').text('$10.00');
    } else if ($totalCart >= 25000){
      $('.rebuy-cart__flyout-apps .insurance-personalized .button-price .price').text('$24.00');
    };

    if($protectPackage === undefined){

      if ($totalCart > 1000) {

        var currentDate = new Date().toDateString();
        var cookieName = 'insurangeAdd_' + currentDate;
        console.log(cookieName);

        if (document.cookie.indexOf(cookieName) === -1) {

          if($totalCart >= 0 && $totalCart <= 24999){
            var data = {"id": 44944921231588,"quantity": 1}; jQuery.ajax({ type: 'POST', url: '/cart/add.js', data: data, dataType: 'json', success: function() { $('#insurange-rebuy').prop('checked', true); }});
          } else if ($totalCart >= 25000){
            var data = {"id": 44944921264356,"quantity": 1}; jQuery.ajax({ type: 'POST', url: '/cart/add.js', data: data, dataType: 'json', success: function() { $('#insurange-rebuy').prop('checked', true); }});
          };
          
          var expireDate = new Date();
          expireDate.setDate(expireDate.getDate() + 1);
          document.cookie = cookieName + '=1; expires=' + expireDate.toUTCString() + '; path=/';
          
        } else {
          $('#insurange-rebuy').prop('checked', false); 
        };
        
      } else {
        $('#insurange-rebuy').prop('checked', false); 
      };
      
    } else {
      $('#insurange-rebuy').prop('checked', true);

      if (!isInsuranceUpdated) {
        if($totalCart <= 1000){
          jQuery.post('/cart/update.js', { updates: { 44944921231588: 0, 44944921264356: 0 }});
          $('#insurange-rebuy').prop('checked', false);
          isInsuranceUpdated = true;
        } else if ($totalCart > 1000 && $totalCart <= 24999){
          jQuery.post('/cart/update.js', { updates: { 44944921231588: 1, 44944921264356: 0 }});
          isInsuranceUpdated = true;
        } else if ($totalCart >= 25000){
          jQuery.post('/cart/update.js', { updates: { 44944921231588: 0, 44944921264356: 1 }});
          isInsuranceUpdated = true;
        };  
      };
      
    };
    
};

function resetIsInsuranceUpdated() {
  isInsuranceUpdated = false;
};

function $cartInsuranceOnly(arrayProducts) {
    var $array_products = arrayProducts;
    function $findInsurange(id) {
        return id.product_id === 8270493352164;
    };
    var $protectPackage = $array_products.find($findInsurange);

    if ($protectPackage !== undefined && $array_products.length === 1) {
        console.log("****El paquete de protección es el único ítem en el carrito.");
        jQuery.post('/cart/update.js', { updates: { 44944921231588: 0, 44944921264356: 0 }});
        console.log("[[[Se ejecuta eliminación de Insurance.]]]");
    } else if ($protectPackage !== undefined) {
        console.log("****El paquete de protección está en el carrito, pero hay más ítems.");
    } else {
        console.log("****El paquete de protección no está en el carrito.");
    };
};

function $totalCart($total_price){
  $('.rebuy-cart__flyout-subtotal').attr( "data-subtotal-cart", $total_price);
};





/* Funcion Delet Gift Mother's Day */

function deletMotherGift(){
  
    $.getJSON('/cart.js', function(cart) {
        // console.log('Carrito obtenido Checked:', cart);
        var updatesObj = {};

        var itemsToDelete = cart.items.filter(item => item.product_id === 8304115155172 && (!item.properties || !item.properties['ID SET']));

        // console.log('Items to Delete:', itemsToDelete);

        itemsToDelete.forEach(function(item) {
            updatesObj[item.key] = 0;
        });

        // console.log('Updates Object:', updatesObj);

        if (Object.keys(updatesObj).length > 0) {
            $.post('/cart/update.js', {
                updates: updatesObj
            }, function(response) {
               //  console.log('Carrito actualizado:', response);
            }).fail(function(error) {
                // console.error('Error al actualizar el carrito', error);
            });
        }
    }).fail(function(error) {
        // console.error('Error al obtener el carrito:', error);
    });

};







function removeGifts(arrayProducts){
  var $array_products = arrayProducts;
  function $productTwo(productId){return productId.product_id === 8656127164644;};var $validationProductTwo = $array_products.find($productTwo);
  if($validationProductTwo !== undefined){
    jQuery.post('/cart/update.js', {
        updates: {
          46369952825572: 0
        }
    })
    .then(response => {
      if (window.location.href === "https://houseofbo.co/cart") {
        location.reload();
      };
    });
  };
  console.log('Se reviso el carrito para sacar los regalos.')
};







/* Script Upgrade Personalization */

function $upsellCustom(products) {
  var $array_products = products;

  const variantMap = {
    '45566480875748': '/products/agua-de-santos-parfum?upsell-personalized-rebuy',
    '45566728765668': '/products/bombon?upsell-personalized-rebuy',
    '45566733877476': '/products/casa-blanca?upsell-personalized-rebuy',
    '45566742626532': '/products/el-sireno?upsell-personalized-rebuy',
    '45566748754148': '/products/espiritu-parfum?upsell-personalized-rebuy',
    '45566759731428': '/products/infinitoud?upsell-personalized-rebuy',
    '45566763892964': '/products/la-mar-parfum?upsell-personalized-rebuy',
    '45566773395684': '/products/oro-verde?upsell-personalized-rebuy',
    '45566791155940': '/products/rosario?upsell-personalized-rebuy',
    '46004326564068': '/products/ave-maria-75ml?upsell-personalized-rebuy',
    '46631315931364': '/products/cosmos-75ml?upsell-personalized-rebuy',
  };

  jQuery.each($array_products, function (index, item) {
    setTimeout(function () {
      var $variantID = item.id;
      var $selectorHTMLProduct = '.rebuy-cart__flyout-items .rebuy-cart__flyout-item:nth-child(' + (index + 1) + ')';
      if (variantMap[$variantID]) {
        let $variantURL = variantMap[$variantID];
        let $button = $($selectorHTMLProduct + ' .add-custom-up-sell-rebuy');
        if ($button.length) {
          $button.replaceWith('<button class="add-custom-up-sell-rebuy" data-url-redirect="' + $variantURL + '" data-id-remove="' + $variantID + '">Upgrade to a 75ML</button>');
        } else {
          $($selectorHTMLProduct).find('.rebuy-cart__flyout-item-info').append('<button class="add-custom-up-sell-rebuy" data-url-redirect="' + $variantURL + '" data-id-remove="' + $variantID + '">Upgrade to a 75ML</button>');
        }
      }
    }, 100);
  });

}


$(document).on('click','button.add-custom-up-sell-rebuy',function(e) {
  var $redirectUpsell = $(this).data('urlRedirect');
  var $removeItem = $(this).parents('.rebuy-cart__flyout-item').find('.rebuy-cart__flyout-item-info button.rebuy-cart__flyout-item-remove');
  $($removeItem).click();
  location.replace($redirectUpsell);
});

window.onload = function() {
  var url = window.location.href;
  
  if (url.indexOf('upsell-personalized-rebuy') !== -1) {
    // $("button#btn-to-cart").click();
    $('span.open10ml').click();
  }

  if (url.indexOf('upsell-rebuy-set') !== -1) {
    function getQueryParams(url) {
      var params = {};
      var parser = new URL(url);
      parser.searchParams.forEach((value, key) => {
        params[key] = value;
      });
      return params;
    }

    var params = getQueryParams(url);

    var idsToActivate = ['one', 'two', 'three']
      .map(param => params[param])
      .filter(Boolean)
      .map(value => `#${CSS.escape(value)}`);

    console.log('Selectors to activate:', idsToActivate);

    idsToActivate.forEach(selector => {
      var checkbox = document.querySelector(selector);
      if (checkbox && checkbox.type === 'checkbox') {
        checkbox.checked = true; // Activa el checkbox
        console.log(`Activated checkbox: ${selector}`);
      } else {
        console.warn(`Checkbox not found or invalid for selector: ${selector}`);
      }
    });

    $("span.add-to-cart.add-to-cart--sets").click();
  }

};





function removeRefillable(arrayProducts){
  
  var $array_products = arrayProducts;

  function $productOne(productId){return productId.product_id === 8605920166116;};var $validationProductOne = $array_products.find($productOne);
  if($validationProductOne !== undefined){
    jQuery.post('/cart/update.js', {
        updates: {
          46135773364452: 0,
          46135773397220: 0,
          46135773429988: 0,
          46135773462756: 0,
          46135773495524: 0,
          46135773528292: 0,
          46135773561060: 0,
          46135773593828: 0,
          46135773626596: 0,
          46672362012900: 0
        }
    })
    .then(response => {
      if (window.location.href === "https://houseofbo.co/cart") {
        location.reload();
      };
    });
  };


  
};





function renderRefillUpgrade(){
  $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-recommendations').prepend(
    '<div class="rebuy-cart__flyout-refill">' +
      '<div class="rebuy-cart__refill-variants">' +
        '<div class="rebuy-cart__refill-variants-container">' +
          '<div class="rebuy-cart__refill-message">' +
            '<h4>Unlock 10ML potion bottles</h4>' +
            '<p>As a valued guest, you now have access to our exclusive 10ML Potion Bottles—offered only at checkout. Select any scent, in any quantity.</p>' +
          '</div>' +
          '<div class="rebuy-cart__refill-variants-content"></div>' +
        '</div>' +
      '</div>' +
    '</div>'
  );

  var $containerRefillesVariants = $(".rebuy-cart__flyout-refill .rebuy-cart__refill-variants .rebuy-cart__refill-variants-container .rebuy-cart__refill-variants-content");
  $.each(ArrayReFillable, function(index, objeto) {
    var htmlRefill = `
      <div class="inputs-variants-refilled product__${objeto.nameHandleize}">
        <div class="inputs-variants-refilled__imagen">
          <img src="${objeto.imagen}" alt="${objeto.name}">
        </div>
        <div class="inputs-variants-refilled__details">
          <h2>${objeto.name}</h2><p class="essence">${objeto.essence}</p><p class="price">${objeto.price}</p>
        </div>
        <div class="inputs-variants-refilled__cta">
          <button class="add-refilled-rebuy" data-variant="${objeto.id}">ADD</button>
        </div>
      </div>
    `;
    $containerRefillesVariants.append(htmlRefill);
  });

  $containerRefillesVariants.slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
};


$(document).on('click','button.add-refilled-rebuy',function(e) {

  let $button = $(this);
  let $variant = $(this).attr('data-variant');
  let $buttonText = $(this).text();

  $button.text('Adding...');
  
  let dataProduct = {
    "id": $variant,
    "quantity": 1
  }
  
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: dataProduct,
    dataType: 'json',
    success: function() {
      $button.text('Added!');
      setTimeout(function () {
        $button.text($buttonText);
      }, 1000);
    },
    error: function(xhr, status, error) {
      setTimeout(function () {
        $button.text($buttonText);
      }, 1000);
    }
  });
});



function refillUpgrade(products){

  var $insurance = 8270493352164;
  var $product = 8605920166116;

  var filteredProducts = products.filter(item => item.product_id !== $insurance && item.product_id !== $product);
  var qty = filteredProducts.reduce((total, item) => total + item.quantity, 0);
  // console.log('👉 Products: ', products);
  // console.log('👉 Total de Productos en el Carrito sin Seguro ni Producto Especial: ' + qty);

  if (qty > 0) {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-refill').show();
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-refill .slick-slider').slick('setPosition');
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-refill').hide();
    removeRefilled(products,$product);
  };
  
};



function removeRefilled(products, productId) {
  var itemsToRemove = products.filter(item => item.product_id === productId);

  itemsToRemove.forEach(item => {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: {
        id: item.key,
        quantity: 0
      },
      dataType: 'json',
      success: function(cart) {
        // console.log('✅ Producto eliminado:', item.product_id);
      },
      error: function(err) {
        // console.error('❌ Error al eliminar el producto:', err);
      }
    });
  });
}















/* Script Events Rebuy */

document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
  const item = event.detail.item;
  if (item.product_id === 8065885929700) {
    // console.log("⚠️ Se eliminó manualmente un regalo. Reseteando la UI...");
    resetInputsRebuy();
  }
});





document.addEventListener('rebuy:smartcart.ready', function(event){

  const smartcart = event.detail.smartcart;
  // console.log('rebuy:smartcart.ready: smartcart', smartcart);

  var $qty = event.detail.smartcart.cart.item_count;
  var $gift = event.detail.smartcart.cart.items;
  var $total_price = event.detail.smartcart.cart.total_price;
  var $array_products = event.detail.smartcart.cart.items;

  $('#rebuy-cart .rebuy-cart__flyout-content').on('scroll', function() {
      const $content = $(this);
      const scrollTop = $content.scrollTop();
      const scrollHeight = $content.prop('scrollHeight');
      const containerHeight = $content.innerHeight();
  
      if (scrollTop > 0) {
          $('#rebuy-cart .rebuy-cart__flyout-header').addClass('scroll-move-header');
      } else {
          $('#rebuy-cart .rebuy-cart__flyout-header').removeClass('scroll-move-header');
      }
  
      if (scrollTop + containerHeight >= scrollHeight - 5) {
          $('#rebuy-cart .rebuy-cart__flyout-footer').addClass('at-bottom');
      } else {
          $('#rebuy-cart .rebuy-cart__flyout-footer').removeClass('at-bottom');
      }
  });
  
  $renderInsurance();
  if($total_price > 0){
    $('.rebuy-cart__flyout-content .insurance-personalized').css('display','flex');
  } else {
    $('.rebuy-cart__flyout-content .insurance-personalized').hide();
  };
  $totalCart($total_price);
  $insurance($total_price,$array_products);
  $cartInsuranceOnly($array_products);
  setTimeout(resetIsInsuranceUpdated, 1500);
  
  
  cartReady();
  btnAddToCartLoad();
  renderGroupSet();
  
  
  
  

  $renderContainer();
  $progressBar($total_price,$gift);


  removeGifts($array_products);
  // removeRefillable($array_products);



  renderRefillUpgrade();
  renderGift();
  giftWithPurchase($qty,$gift);
  refillUpgrade($array_products);

  
  
  
  setTimeout(GroupSet, 1000);


  deletMotherGift();
});



document.addEventListener('rebuy:cart.change', function(event){

  // console.log('rebuy:cart.change event', event.detail); 
  
  var $containerSets = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-sets');
  var $containerGift = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-gift');
  var $container_progress = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .container-progress-bar');
  var $containerInsurance = $('.rebuy-cart__flyout-apps .insurance-personalized');
  
  var $qty = event.detail.cart.cart.item_count;
  var $gift = event.detail.cart.cart.items
  var $total_price = event.detail.cart.cart.total_price;
  var $array_products = event.detail.cart.cart.items;
  
  $('span.cart-link.open-cart-rebuy .cart-link__count1').text('(' + $qty + ')');

  if ($container_progress.length > 0) {
    $progressBar($total_price,$gift)
  };
  
  if ($containerGift.length > 0) {
    giftWithPurchase($qty,$gift);
  };   
  
  if ($containerSets.length > 0) {
    setTimeout(GroupSet, 1000);
  };

  
  deletMotherGift();

  if (window.location.href !== "https://houseofbo.co/pages/summer-sampling") {
    removeGifts($array_products); 
  };

  // removeRefillable($array_products);
  

  $totalCart($total_price);
  if($total_price > 0){
    $('.rebuy-cart__flyout-content .insurance-personalized').css('display','flex');
  } else {
    $('.rebuy-cart__flyout-content .insurance-personalized').hide();
  };
  if ($containerInsurance.length > 0) {
    $insurance($total_price,$array_products);
    $cartInsuranceOnly($array_products);
    setTimeout(resetIsInsuranceUpdated, 1500);
  };


  var $containerRefilled = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-refill');
  if ($containerRefilled.length > 0) {
    refillUpgrade($array_products);
  };   




  

  $upsellCustom($array_products);
  
});


/* Trigger Insurance */

$(document).on('change', '#insurange-rebuy', function() {
  var $totalCart = $('.rebuy-cart__flyout-subtotal').attr('data-subtotal-cart');
  if ($(this).is(':checked')){
    if($totalCart >= 0 && $totalCart <= 24999){
      var data = {"id": 44944921231588,"quantity": 1}; jQuery.ajax({ type: 'POST', url: '/cart/add.js', data: data, dataType: 'json', success: function() {console.log('Add Protect Package');}});
    } else if ($totalCart >= 25000){
      var data = {"id": 44944921264356,"quantity": 1}; jQuery.ajax({ type: 'POST', url: '/cart/add.js', data: data, dataType: 'json', success: function() {console.log('Add Protect Package');}});
    };
  } else {
    jQuery.post('/cart/update.js', { updates: { 44944921231588: 0, 44944921264356: 0 }});
  };
});





document.addEventListener('rebuy:cart.add', (event) => { 
    console.log('🛒 Producto agregado desde Rebuy:', event.detail); 

    let item = event.detail.item;

    let productIdsToModify = [
        8032285622500, 8163953508580, 8163931390180, 7803030667492, 8032273334500, 8032091898084, 8163877683428, 7803025948900, 8580057301220,
        8498839355620, 8498888966372, 8498890277092, 8498891489508, 8498892308708, 8498894012644, 8498894897380, 8498897223908, 8498900107492,
        8580147118308, 8713300902116, 8687926280420
    ];

    if (productIdsToModify.includes(item.product_id)) {
        // console.log("🎯 Producto necesita propiedad personalizada, buscando en el carrito...");
        jQuery.getJSON('/cart.js', function(cart) {
            let cartItem = cart.items.find(cartItem => cartItem.variant_id === item.variant_id);
            if (cartItem) {
                // console.log("🔄 Producto encontrado en el carrito. Agregando propiedad...");
                let dataUpdate = {
                    id: cartItem.key,
                    quantity: cartItem.quantity,
                    properties: {
                        'INCLUDES GIFT': 'Velvet Dust Bag'
                    }
                };

                jQuery.ajax({
                    type: "POST",
                    url: "/cart/change.js",
                    data: dataUpdate,
                    dataType: "json",
                    success: function(response) {
                        // console.log("✅ Propiedad personalizada agregada:", response);
                    },
                    error: function(xhr, status, error) {
                        // console.error("❌ Error al actualizar el producto en el carrito:", xhr.responseText);
                    }
                });
            } else {
                // console.warn("⚠️ No se encontró el producto en el carrito después del tiempo de espera.");
            }
        });

    }
});









/* Script para SETS */

function renderGroupSet(){
  $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content').prepend('<div class="rebuy-cart__flyout-sets"><h4 id="heading-product-sets">Product Sets:</h4></div><div class="title-simple-products">Individual Products:</div>');
};



function GroupSet(){

  var grupos = {};
  var cantidadElementos = 0;
  var lineItemsBasic = 0;
    
  $("div#rebuy-cart ul.rebuy-cart__flyout-items li.rebuy-cart__flyout-item").each(function() {
  
      var classes = $(this).attr("class").split(" ");
      var idClass = classes.find(function(className) {
          return className.startsWith("property-id-set:"); 
      });
  
      if (idClass) {
          var id = idClass.split(":")[1];
        
          if (!grupos[id]) {
              grupos[id] = [];
          };
          
          grupos[id].push(this);
      } else {
        
        lineItemsBasic++;
        
      };

      if (classes.includes("tag-dust-bag-gift")) {

        let product = $(this);
        let giftSection = $(this).find('.rebuy-cart__flyout-item-gift');

        if(giftSection.length === 0){
          product.append(`
            <div class="rebuy-cart__flyout-item-gift">
              <div class="rebuy-cart__flyout-item-gift__imagen"><img src="https://cdn.shopify.com/s/files/1/0568/3301/6007/files/Velvet_Dust_Bag_x100.png"></div>
              <div class="rebuy-cart__flyout-item-gift__details">
                <p class="heading">VELVET DUST BAG</p>
                <p class="price">$0.00</p>
              </div>
            </div>
          `);
        }
        
        // console.log("🎁 Se detectó un producto con la etiqueta de regalo Dust Bag:", this);
      }
      
  });

  for (var id in grupos) {
    if($('div#rebuy-cart .rebuy-cart__flyout-sets ul.' + id).length === 0){

      var priceTravelSetAmount = 120;
      var crosslinePrice = (20 / 100);
      var discount = (1 - crosslinePrice) * priceTravelSetAmount;

      if(discount == priceTravelSetAmount){
        var priceTravelSet = '$'+ priceTravelSetAmount +'.00';
      } else {
        var regularTravelSet = '$'+ priceTravelSetAmount +'.00';
        var offerTravelSet = discount.toLocaleString('en-US', {style: 'currency', currency: 'USD', minimumFractionDigits: 2});
        var priceTravelSet = '<span>' + '$98.00' + '<b>' + regularTravelSet + '</b></span>';
      };

      

      var lista = $("<ul class='" + id + "'></ul>");
      
      var containerSet = $(`
        <div class="container-set-rebuy container-set-rebuy--${id}">
          <div class="rebuy-cart__flyout-item">
            <div class="rebuy-cart__flyout-item-media">
              <a href="/products/tesoro-discovery-travel-set-new-config" tabindex="-1">
                <img src="https://cdn.shopify.com/s/files/1/0568/3301/6007/files/DTSv2COMP_240x240.png?v=1696012980" alt="TESORO DISCOVERY TRAVEL SET">
              </a>
            </div>
            <div class="rebuy-cart__flyout-item-info">
              <a role="heading" aria-level="5" href="/products/tesoro-discovery-travel-set-new-config" alt="View TESORO DISCOVERY TRAVEL SET" class="rebuy-cart__flyout-item-product-title">
                TESORO DISCOVERY TRAVEL SET
              </a>
              <div class="rebuy-cart__flyout-item-properties">
                <div class="rebuy-cart__flyout-item-property property-key-id-set">
                  <span class="rebuy-cart__flyout-item-property-name">ID SET</span>
                  <span class="rebuy-cart__flyout-item-property-separator">:</span>
                  <span class="rebuy-cart__flyout-item-property-value">${id}</span>
                </div>
              </div>
              <button type="button" class="rebuy-cart__flyout-item-remove">
                <i aria-hidden="true" class="far fa-trash"></i>
              </button>
              <div class="rebuy-cart__flyout-item-quantity">
                <div class="container-button-view-all-products">
                  <span class="view-products button-active">View Products</span>
                </div>
              </div>
              <div class="rebuy-cart__flyout-item-price">
                <div>
                  <span class="rebuy-money"><span class="sr-only">Price</span> <span>${priceTravelSet}</span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      `);



      
      var elementosOriginales = grupos[id];


      if (elementosOriginales.length >= 2) {
        elementosOriginales.forEach(function(elementoOriginal) {
            var copiaElemento = $(elementoOriginal).clone();
            lista.append(copiaElemento);
        }); 
      };
      

      $('.rebuy-cart__flyout-sets').prepend(containerSet);
      $('.rebuy-cart__flyout-sets .container-set-rebuy--' + id +'').append(lista);
      
    };

    cantidadElementos++;

  };


  $('.rebuy-cart__flyout-sets').prepend($('#heading-product-sets'));


  $('.rebuy-cart__flyout-sets .container-set-rebuy').each(function(){
      var selector = $(this).find('> div.rebuy-cart__flyout-item');
      var items = $(this).find('ul li');
      items.each(function(){

          // REGALO EN TESORO 75ML: Coloca Titulos, Precios, Links e Imagenes
          if($(this).hasClass('property-value-75ml-bottle')){
              var gift = $(this).siblings('.rebuy-cart__flyout-item').find('.rebuy-cart__flyout-item-info > .rebuy-cart__flyout-item-variant-title').text();
              var giftText = ("GIFT: " + gift + " 10ml").toUpperCase();
            
              var urlChange = $(this).find('.rebuy-cart__flyout-item-media > a').attr('href');
              var imagenChange = $(this).find('.rebuy-cart__flyout-item-media > a > img').attr('src'); 
              var nameChange = $(this).find('.rebuy-cart__flyout-item-info > a').text();
              var priceElements = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)');
  
              $(selector).find('.rebuy-cart__flyout-item-media > a').attr('href', urlChange);
              $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', imagenChange);
              $(selector).find('.rebuy-cart__flyout-item-info > a').attr('href', urlChange);
              $(selector).find('.rebuy-cart__flyout-item-info > a').text(nameChange + ' + ' + giftText);
  
              if(priceElements.length > 1){
                var prices = priceElements.map(function() {
                    return $(this).text();
                }).get();
                var priceOffer = prices[0];priceOffer
                var priceRegular = prices[1];
                $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)').replaceWith('<span>' + priceOffer + '<b>' + priceRegular + '</b></span>');
              } else {
                var priceText = priceElements.text();
                $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)').text(priceText);    
              };
          };



          // REGALO EN TESORO 40ML: Coloca Titulos, Precios, Links e Imagenes
          if($(this).hasClass('property-value-40ml-bottle')){
              var gift = $(this).siblings('.rebuy-cart__flyout-item').find('.rebuy-cart__flyout-item-info > .rebuy-cart__flyout-item-variant-title').text();
              var giftText = ("GIFT: " + gift + " 10ml").toUpperCase();
            
              var urlChange = $(this).find('.rebuy-cart__flyout-item-media > a').attr('href');
              var imagenChange = $(this).find('.rebuy-cart__flyout-item-media > a > img').attr('src'); 
              var nameChange = $(this).find('.rebuy-cart__flyout-item-info > a').text();
              var priceElements = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)');
  
              $(selector).find('.rebuy-cart__flyout-item-media > a').attr('href', urlChange);
              $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', imagenChange);
              $(selector).find('.rebuy-cart__flyout-item-info > a').attr('href', urlChange);
              $(selector).find('.rebuy-cart__flyout-item-info > a').text(nameChange + ' + ' + giftText);
  
              if(priceElements.length > 1){
                var prices = priceElements.map(function() {
                    return $(this).text();
                }).get();
                var priceOffer = prices[0];priceOffer
                var priceRegular = prices[1];
                $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)').replaceWith('<span>' + priceOffer + '<b>' + priceRegular + '</b></span>');
              } else {
                var priceText = priceElements.text();
                $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)').text(priceText);    
              };
          };

        
          // SET EN TESORO DISCOVERY TRAVEL SET:
          if ($(this).hasClass('property-key-tesoro-discovery-travel-set')) {
            $(selector).parents('.container-set-rebuy').addClass('tesoro-discovery-travel-set');
            var $selectorHTML = $(selector).parents('.container-set-rebuy');
            if ($selectorHTML.find('.add-custom-up-sell-rebuy-set').length) {
              $selectorHTML.find('.add-custom-up-sell-rebuy-set').replaceWith(
                '<button class="add-custom-up-sell-rebuy-set" data-url-redirect="/products/tesoro-collection-gift-set">Upgrade and Save</button>'
              );
            } else {
              var $container = $selectorHTML.find('.container-button-view-all-products');
              if ($container.length) {
                $container.prepend(
                  '<button class="add-custom-up-sell-rebuy-set" data-url-redirect="/products/tesoro-collection-gift-set">Upgrade and Save</button>'
                );
              } else {
                console.warn('Container not found for', $selectorHTML);
              }
            }
          };



        
          // SET EN TESORO COLLECTION GIFT: Coloca Titulos, Precios, Links e Imagenes
          if($(this).hasClass('property-value-tesoro-set-box')){
              var urlChange = 'https://houseofbo.co/products/tesoro-collection-gift-set';
              var imagenChange = 'https://cdn.shopify.com/s/files/1/0568/3301/6007/files/Untitled_design_0d96e811-e03e-45f1-bc68-4f28213c67cc_240x240.png'; 
              var nameChange = 'TESORO COLLECTION GIFT SET';

              var priceElements = '$985.00';
              var comparePriceElements = '$1,160.00';

              $(selector).find('.rebuy-cart__flyout-item-media > a').attr('href', urlChange);
              $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', imagenChange);
              $(selector).find('.rebuy-cart__flyout-item-info > a').attr('href', urlChange);
              $(selector).find('.rebuy-cart__flyout-item-info > a').text(nameChange);
              $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)').replaceWith('<span>' + priceElements + '<b>' + comparePriceElements + '</b></span>');
          };


          // SUMMER SET: Coloca Titulos, Precios, Links e Imagenes
          if($(this).hasClass('property-value-summer-set-box')){
              var urlChange = 'https://houseofbo.co/products/summer-sets';
              var imagenChange = 'https://cdn.shopify.com/s/files/1/0568/3301/6007/files/DTSv2COMP_240x240.png'; 
              var nameChange = 'SUMMER SET';
              var priceElements = '$98.00';
              var nameSet = $(this).find('.rebuy-cart__flyout-item-properties .property-key-set .rebuy-cart__flyout-item-property-value').text();
              
              $(selector).find('.rebuy-cart__flyout-item-media > a').attr('href', urlChange);
              $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', imagenChange);
              $(selector).find('.rebuy-cart__flyout-item-info > a').attr('href', urlChange);
              $(selector).find('.rebuy-cart__flyout-item-info > a').text(nameChange);
              $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)').text(priceElements);
  
              if ($(selector).find('.rebuy-cart__flyout-item-property.property-key-set').length === 0) {
                  $(selector).find('.rebuy-cart__flyout-item-info > .rebuy-cart__flyout-item-properties').prepend(`
                      <div class="rebuy-cart__flyout-item-property property-key-set">
                        <span class="rebuy-cart__flyout-item-property-name">SET</span>
                        <span class="rebuy-cart__flyout-item-property-separator">:</span>
                        <span class="rebuy-cart__flyout-item-property-value">${nameSet}</span>
                      </div>
                  `);
              }
          }




          // DISCOVERY TRAVEL COFFRET: Coloca Titulos, Precios, Links e Imagenes
          if($(this).hasClass('property-key-discovery-travel-coffret')){
              var urlChange = 'https://houseofbo.co/products/discovery-travel-coffret';
              var imagenChange = 'https://houseofbo.co/cdn/shop/files/Coffret-Comp_240x240.png'; 
              var nameChange = 'DISCOVERY TRAVEL COFFRET';
              var priceElements = '$290.00';
              var comparePriceElements = '$360.00';
              
              $(selector).find('.rebuy-cart__flyout-item-media > a').attr('href', urlChange);
              $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', imagenChange);
              $(selector).find('.rebuy-cart__flyout-item-info > a').attr('href', urlChange);
              $(selector).find('.rebuy-cart__flyout-item-info > a').text(nameChange);
              $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)').replaceWith('<span>' + priceElements + '<b>' + comparePriceElements + '</b></span>');

          };
        


        

          // DUST BAG GIFT: Coloca Titulos, Precios, Links e Imagenes
          if($(this).hasClass('tag-dust-bag-gift')){

            let giftSectionSet = $(selector).find('.rebuy-cart__flyout-item-gift');
            if(giftSectionSet.length === 0){
              selector.append(`
                <div class="rebuy-cart__flyout-item-gift">
                  <div class="rebuy-cart__flyout-item-gift__imagen"><img src="https://cdn.shopify.com/s/files/1/0568/3301/6007/files/Velvet_Dust_Bag_x100.png"></div>
                  <div class="rebuy-cart__flyout-item-gift__details">
                    <p class="heading">VELVET DUST BAG</p>
                    <p class="price">$0.00</p>
                  </div>
                </div>
              `);
            }

            
          }

        
      });
  });



  function allItemsHidden() {
    return $("ul.rebuy-cart__flyout-items li").filter(function() {
        return $(this).css("display") !== "none";
    }).length === 0;
  }

  if (lineItemsBasic > 0 && !allItemsHidden()) {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-items').show();
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-items').hide();
    lineItemsBasic = 0;
  }


  if (cantidadElementos > 0){
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets').css('display','flex');
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets').hide();
  }

  if (cantidadElementos > 0 && lineItemsBasic > 0){
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets h4').show();
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .title-simple-products').show();
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets h4').hide();
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .title-simple-products').hide();
  }


};




$(document).on('click', '.container-set-rebuy button.rebuy-cart__flyout-item-remove', function () {
    var $selectorItem = ($(this).parents('.container-set-rebuy').find('> ul').attr('class')).toUpperCase();
    var $selectorProducts = $(this).parents('.container-set-rebuy').find('> ul').attr('class');
    console.log('Selector Products:', $selectorItem);

    var $removeSet = $('.rebuy-cart__flyout-sets .container-set-rebuy--' + $selectorProducts);
    $($removeSet).replaceWith('<div class="container-set-rebuy--' + $selectorProducts +' rebuy-cart__flyout-sets--deleted"><div class="load-more__spinner"></div><p>Remove set</p></div>');

    $.getJSON('/cart.js', function(cart) {
        console.log('Carrito obtenido:', cart);
        var updatesObj = {};

        var itemsToDelete = cart.items.filter(item => item.properties && item.properties['ID SET'] === $selectorItem);
        console.log('Items to Delete:', itemsToDelete);

        itemsToDelete.forEach(function(item) {
            updatesObj[item.key] = 0;
        });

        console.log('Updates Object:', updatesObj);

        if (Object.keys(updatesObj).length > 0) {
            $.post('/cart/update.js', {
                updates: updatesObj
            }, function(response) {
                console.log('Carrito actualizado:', response);
                $('.container-set-rebuy--' + $selectorProducts).remove();
            }).fail(function(error) {
                console.error('Error al actualizar el carrito', error);
            });
        }
    }).fail(function(error) {
        console.error('Error al obtener el carrito:', error);
    });
});


/*
$(document).on('click', '.container-set-rebuy button.add-custom-up-sell-rebuy-set', function () {
    var $selectorItem = ($(this).parents('.container-set-rebuy').find('> ul').attr('class')).toUpperCase();
    var $selectorProducts = $(this).parents('.container-set-rebuy').find('> ul').attr('class');
    console.log('Selector Products:', $selectorItem);

    var $removeSet = $('.rebuy-cart__flyout-sets .container-set-rebuy--' + $selectorProducts);

    var $perfumOne = '75ml-parfum__' + $($removeSet).find('li.property-value-scent-1-of-3 .rebuy-cart__flyout-item-variant-title').text().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-'); 
    var $perfumTwo = '75ml-parfum__' + $($removeSet).find('li.property-value-scent-2-of-3 .rebuy-cart__flyout-item-variant-title').text().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-'); 
    var $perfumThree = '75ml-parfum__' + $($removeSet).find('li.property-value-scent-3-of-3 .rebuy-cart__flyout-item-variant-title').text().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '-'); 
    var urlRedirectSet = '/products/tesoro-collection-gift-set?upsell-rebuy-set&one=' + $perfumOne + '&two='+ $perfumTwo + '&three=' + $perfumThree;

    $($removeSet).replaceWith('<div class="container-set-rebuy--' + $selectorProducts +' rebuy-cart__flyout-sets--deleted"><div class="load-more__spinner"></div><p>Upsell to 3 x 75ml</p></div>');

    $.getJSON('/cart.js', function(cart) {
        console.log('Carrito obtenido:', cart);
        var updatesObj = {};

        var itemsToDelete = cart.items.filter(item => item.properties && item.properties['ID SET'] === $selectorItem);
        console.log('Items to Delete:', itemsToDelete);

        itemsToDelete.forEach(function(item) {
            updatesObj[item.key] = 0;
        });

        console.log('Updates Object:', updatesObj);

        if (Object.keys(updatesObj).length > 0) {
            $.post('/cart/update.js', {
                updates: updatesObj
            }, function(response) {
                console.log('Carrito actualizado:', response);
                $('.container-set-rebuy--' + $selectorProducts).remove();
                location.replace(urlRedirectSet);
            }).fail(function(error) {
                console.error('Error al actualizar el carrito', error);
            });
        }
    }).fail(function(error) {
        console.error('Error al obtener el carrito:', error);
    });
});
*/


$(document).on('click', '.container-set-rebuy button.add-custom-up-sell-rebuy-set', function () {
    var $selectorItem = ($(this).parents('.container-set-rebuy').find('> ul').attr('class')).toUpperCase();
    var $selectorProducts = $(this).parents('.container-set-rebuy').find('> ul').attr('class');
    console.log('Selector Products:', $selectorItem);

    var $removeSet = $('.rebuy-cart__flyout-sets .container-set-rebuy--' + $selectorProducts);
    $($removeSet).replaceWith('<div class="container-set-rebuy--' + $selectorProducts +' rebuy-cart__flyout-sets--deleted"><div class="load-more__spinner"></div><p>Upgrade to 9 x 10ml</p></div>');

    $.getJSON('/cart.js', function(cart) {
        console.log('Carrito obtenido:', cart);
        var updatesObj = {};

        var itemsToDelete = cart.items.filter(item => item.properties && item.properties['ID SET'] === $selectorItem);
        console.log('Items to Delete:', itemsToDelete);

        itemsToDelete.forEach(function(item) {
            updatesObj[item.key] = 0;
        });

        console.log('Updates Object:', updatesObj);

        if (Object.keys(updatesObj).length > 0) {
            $.post('/cart/update.js', {
                updates: updatesObj
            }, function(response) {
                console.log('Carrito actualizado:', response);
                $('.container-set-rebuy--' + $selectorProducts).remove();
                location.replace('/products/discovery-travel-coffret?upsell-personalized-rebuy');
            }).fail(function(error) {
                console.error('Error al actualizar el carrito', error);
            });
        }
    }).fail(function(error) {
        console.error('Error al obtener el carrito:', error);
    });
});


$(document).on('click', '.container-set-rebuy .container-button-view-all-products span.view-products.button-active', function (){
  $(this).parents('.container-set-rebuy').find('> ul').slideDown();
  $(this).text('Hide Products');
  $(this).removeClass('button-active');
  $(this).addClass('button-off');
});

$(document).on('click', '.container-set-rebuy .container-button-view-all-products span.view-products.button-off', function (){
  $(this).parents('.container-set-rebuy').find('> ul').slideUp();
  $(this).text('View Products');
  $(this).removeClass('button-off');
  $(this).addClass('button-active');
});